import { Routes } from '@angular/router';
import {DespachadorComponent} from "./despachador/despachador.component";
import {NavigationComponent} from "./navigation/navigation.component";
import {GestionJornadaComponent} from "./gestion-jornada/gestion-jornada.component";
import {GestionConductoresComponent} from "./gestion-conductores/gestion-conductores.component";
import {SinopticoComponent} from "./sinoptico/sinoptico.component";
import {GestionBusesComponent} from "./gestion-buses/gestion-buses.component";
import {ImportadorComponent} from "./importador/importador.component";
import {ErrorSinPermisoComponent} from "./error-sin-permiso/error-sin-permiso.component";
import {SinopticoGuard} from "./guards/sinoptico.guard";
import {GestionBusesGuard} from "./guards/gestion-buses.guard";
import {DespachadorGuard} from "./guards/despachador.guard";
import {ImportadorGuard} from "./guards/importador.guard";
import {GestionJornadaGuard} from "./guards/gestion-jornada.guard";
import {GestionConductoresGuard} from "./guards/gestion-conductores.guard";

export const routes: Routes = [



  { path: 'admin', component: NavigationComponent,
    children: [
      {path: 'gestion-jornada', component: GestionJornadaComponent, canActivate: [GestionJornadaGuard] },
      {path: 'gestion-conductores', component: GestionConductoresComponent, canActivate: [GestionConductoresGuard] },
      {path: 'despachador', component: DespachadorComponent, canActivate: [DespachadorGuard] },
      {path: 'sinoptico', component: SinopticoComponent, canActivate: [SinopticoGuard] },
      {path: 'gestion-buses', component: GestionBusesComponent, canActivate: [GestionBusesGuard] },
      {path: 'importador', component: ImportadorComponent, canActivate: [ImportadorGuard] }
    ]
  },
  { path: 'error-sin-permiso', component: ErrorSinPermisoComponent },
  { path: '**', redirectTo: 'admin/despachador', pathMatch: 'full' }
];
